import ConfirmAsanImza from './ConfirmAsanImza';

export default ConfirmAsanImza;
